import { H4 } from 'assets/styled';
import { Formik } from 'formik';
import {
  ColumnContainer,
  FormikOuter,
  FormWrapper,
  Heading,
  RowSpaceBetween,
} from '../EditCompanyDataModal.styled';
import { Input as FormikInput } from 'components/Input/InputFormik';
import { useTranslation } from 'react-i18next';
import { editDetailsTabSchema } from '../validation';
import { ICompanyDetails } from '../../types';
import { useBreakpointFlag } from 'utils/hooks/useBreakpointFlag';

interface IDetailsTabProps {
  details: ICompanyDetails;
  setDetails: (details: ICompanyDetails) => void;
  setIsValid: (isValid: boolean) => void;
}
export const DetailsTab = ({
  details,
  setDetails,
  setIsValid,
}: IDetailsTabProps) => {
  const { t } = useTranslation();
  const { isSmallTablet } = useBreakpointFlag();

  return (
    <FormikOuter>
      <Formik
        enableReinitialize
        onSubmit={() => {
          //
        }}
        validationSchema={editDetailsTabSchema}
        initialValues={details}
      >
        {({ values, setFieldValue, handleBlur, errors, isValid }) => {
          const handleBlurFunction = (e: any, name: string) => {
            const value = e.target.value.trim();
            setFieldValue(name, value);
            setDetails(values);
            handleBlur(e);
            setIsValid(isValid);
          };
          return (
            <FormWrapper>
              <RowSpaceBetween>
                <ColumnContainer>
                  <Heading>
                    <H4>{t('Name')}</H4>
                  </Heading>
                  <FormikInput
                    errorMessage={
                      errors['name'] ? (errors['name'] as string) : ''
                    }
                    onBlur={(e) => {
                      handleBlurFunction(e, 'name');
                    }}
                    height={'43rem'}
                    name="name"
                    wrapperStyles={{
                      width: isSmallTablet ? '100%' : '300rem',
                      marginTop: '10rem',
                    }}
                  />
                </ColumnContainer>
                <ColumnContainer>
                  <Heading>
                    <H4>{t('VAT number')}</H4>
                  </Heading>
                  <FormikInput
                    errorMessage={
                      errors['vat_number']
                        ? (errors['vat_number'] as string)
                        : ''
                    }
                    onBlur={(e) => {
                      handleBlurFunction(e, 'vat_number');
                    }}
                    height={'43rem'}
                    name="vat_number"
                    wrapperStyles={{
                      width: isSmallTablet ? '100%' : '300rem',
                      marginTop: '10rem',
                    }}
                  />
                </ColumnContainer>
              </RowSpaceBetween>

              <RowSpaceBetween>
                <ColumnContainer>
                  <Heading>
                    <H4>{t('COC number')}</H4>
                  </Heading>
                  <FormikInput
                    errorMessage={
                      errors['coc_number']
                        ? (errors['coc_number'] as string)
                        : ''
                    }
                    onBlur={(e) => {
                      handleBlurFunction(e, 'coc_number');
                    }}
                    height={'43rem'}
                    name="coc_number"
                    wrapperStyles={{
                      width: isSmallTablet ? '100%' : '300rem',
                      marginTop: '10rem',
                    }}
                  />
                </ColumnContainer>

                <ColumnContainer>
                  <Heading>
                    <H4>{t('Phone number')}</H4>
                  </Heading>
                  <FormikInput
                    errorMessage={
                      errors['phone_number']
                        ? (errors['phone_number'] as string)
                        : ''
                    }
                    onBlur={(e) => {
                      handleBlurFunction(e, 'phone_number');
                    }}
                    height={'43rem'}
                    name="phone_number"
                    wrapperStyles={{
                      width: isSmallTablet ? '100%' : '300rem',
                      marginTop: '10rem',
                    }}
                  />
                </ColumnContainer>
              </RowSpaceBetween>

              <RowSpaceBetween>
                <ColumnContainer>
                  <Heading>
                    <H4>{t('Website')}</H4>
                  </Heading>
                  <FormikInput
                    errorMessage={
                      errors['website'] ? (errors['website'] as string) : ''
                    }
                    onBlur={(e) => {
                      handleBlurFunction(e, 'website');
                    }}
                    height={'43rem'}
                    name="website"
                    wrapperStyles={{
                      width: isSmallTablet ? '100%' : '300rem',
                      marginTop: '10rem',
                    }}
                  />
                </ColumnContainer>
                <ColumnContainer>
                  <Heading>
                    <H4>{t('Email')}</H4>
                  </Heading>
                  <FormikInput
                    errorMessage={
                      errors['email'] ? (errors['email'] as string) : ''
                    }
                    onBlur={(e) => {
                      handleBlurFunction(e, 'email');
                    }}
                    height={'43rem'}
                    name="email"
                    wrapperStyles={{
                      width: isSmallTablet ? '100%' : '300rem',
                      marginTop: '10rem',
                    }}
                  />
                </ColumnContainer>
              </RowSpaceBetween>
            </FormWrapper>
          );
        }}
      </Formik>
    </FormikOuter>
  );
};
